<template>
    <div @click="show_detail()">
        <div class="item-img">
            <img :src="p_info.thumb" />
        </div>
        <div class="item-name">{{product_name}}</div>
        <div class="item-price">
            <span class="label">拼团价</span>
            <span class="val">￥{{p_info.group_price}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SaleGroupItem",
        props:{
            p_info:{
                type:Object,
                default:null,
                required:true,
            },
        },
        data(){
            return{
                product_name:this.p_info.product_name.substring(0,8),
            }
        },
        methods:{
            show_detail(){
                // if(this.p_product.pub_status==2){
                //     if(this.mode==1){
                //         let sales_uid=this.sales_uid;
                //         this.$router.push({ name: 'ProductDetailSale',params: {product_id:val,sales_uid}});
                //     }else{
                //         this.$router.push({ name: 'ProductDetail',params: {product_id:val}});
                //     }
                // }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .item-img{
        font-size:0;
        img {
            width: 120px;
            height: 120px;
        }
    }
    .item-name{
        text-align: left;
        padding-left: 2px;
        font-size: 12px;
        color: #666666;
    }
    .item-price{
        text-align: left;
        padding-left: 2px;
        .label{
            font-size: 10px;
            color: #999999;
        }
        .val{
            font-size: 14px;
            color: #E34928;
        }
    }

</style>
